import { DateSerializable } from '../DateSerializable';
import { Schema, SchemaGetter } from 'effect';

import { DateValidatedIsoString } from './DateValidatedIsoString';

/**
 * Schema that transforms ISO date string (YYYY-MM-DD) to SerializableDate.
 * Useful for API responses with date-only fields (format: "date" in OpenAPI).
 *
 * Decode: `"2024-12-10"` → `{ _tag: 'Date', value: '2024-12-10' }`
 * Encode: `{ _tag: 'Date', value: '2024-12-10' }` → `"2024-12-10"`
 *
 * Validates that the string is a valid ISO 8601 date using LocalDate.parse()
 * to prevent invalid dates like 2024-02-30 from being accepted.
 */
export const DateSerializableFromString = DateValidatedIsoString.pipe(
  Schema.decodeTo(DateSerializable, {
    decode: SchemaGetter.transform((validatedIsoDate: string) =>
      DateSerializable.make({
        _tag: 'Date',
        value: validatedIsoDate,
      })
    ),
    encode: SchemaGetter.transform((serializableDate) => serializableDate.value),
  })
);

export type DateSerializableFromString = Schema.Schema.Type<typeof DateSerializableFromString>;
